import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
`

export const Icon = styled.div`
  width: 15px;
  height: 15px;
  margin: 0 10px;
  border-radius: 50%;
  background-color: green;

  ${(props) =>
    props.$error &&
    css`
      background-color: red;
    `}

  ${(props) =>
    props.$loading &&
    css`
      background-color: yellow;
    `}
`
